





















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";

@Component
export default class MediCsvResultDialog extends Vue {
  @Prop({ default: "OK" }) buttonOK!: string;
  @Prop({ default: "" }) resultMessage!: string;

  private isActive = false;

  // 表示するメッセージを生成
  private get displayMessage(): string {
    const msg = (this.resultMessage || "").trim();
    if (!msg || msg === "") {
      return "";
    }
    return (
      "今回の出力にのみ下記の変更をしています。\n" +
      "iBowで登録済みの情報には影響しません。\n\n" +
      msg
    );
  }

  public open() {
    this.isActive = true;
  }

  @Emit()
  private download() {
    return;
  }

  @Emit()
  private reload() {
    return;
  }

  private ok() {
    this.isActive = false;
  }
}
